module.exports = __webpack_public_path__ + "lady-1.svg?f5bbdf5f398083455f868a9664e8fca4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lady-1.svg
// module id = 57
// module chunks = 0